import axios from 'axios';

export interface PurchaseCreditsResponse {
    url: string;
    sessionId: string;
}

export const creditsService = {
    async purchaseCredits(amount: number): Promise<PurchaseCreditsResponse> {
        const response = await axios.post('/api/credits/purchase', { amount });
        return response.data;
    },
    sendPaymentRequestToReactNative(plan: any, sendMessage: (msg: { action: string; payload?: any }) => void): void {
        console.log('🟤 [CreditsService] sendPaymentRequestToReactNative called with plan:', {
            credits: plan.credits,
            price: plan.price,
            revenueCatProductId: plan.revenueCatProductId
        });

        const message = { action: 'purchaseCredits', payload: plan.revenueCatProductId as string };
        console.log('🟤 [CreditsService] Sending message to React Native:', message);

        sendMessage(message);

        console.log('🟤 [CreditsService] Message sent successfully');
    }
};

